module.exports = __webpack_public_path__ + "img/images.5843e5f8.png";